import { G } from '@mobily/ts-belt';

import type { BulkCreateEmployeeOverrides } from '@Common/types/bo/b2b/employees/bulk_create';

export function hasIgnoredOverrides(
  ignoredOverrides: BulkCreateEmployeeOverrides | undefined,
): boolean {
  return G.isNotNullable(ignoredOverrides) && Object.keys(ignoredOverrides).length > 0;
}
